/** Rows by key, each list in the rows' order (one pass, for the loaders' indexes). */
export function groupBy<T, K>(rows: readonly T[], key: (r: T) => K): Map<K, T[]> {
  const out = new Map<K, T[]>();
  for (const r of rows) {
    const k = key(r);
    const list = out.get(k);
    list ? list.push(r) : out.set(k, [r]);
  }
  return out;
}
